import React, { Component } from "react";

export const SeniorenplatformPagination = (props) => {
    return (
        <div className="c-senioren__pagination">                
            <button className="c-senioren__button c-senioren__button--primary c-senioren__button--pagination" disabled={props.disabledMin} onClick={() => props.pageDown()}><i className="fa fa-angle-left fa-lg"></i></button>
            <SeniorenPaginationText 
            pageValueMin={props.pageValueMin}
            pageValueMax={props.pageValueMax}
            totalItems={props.totalItems}
            dictionary={props.dictionary}
            />
            <button className="c-senioren__button c-senioren__button--primary c-senioren__button--pagination" disabled={props.disabledMax} onClick={() => props.pageUp()}><i className="fa fa-angle-right fa-lg"></i></button>
        </div>
    );
}

export const SeniorenPaginationText = ({pageValueMin, paginationTot, pageValueMax, dictionary, totalItems, ... props}) => {
    return <span className="content"><strong>{pageValueMin && pageValueMin.toString()} {dictionary.paginationTot} {pageValueMax&& pageValueMax.toString()}</strong> {dictionary.paginationVan} {totalItems && totalItems.toString()}</span>
}